import React, { useContext, useEffect } from "react";
import styled from "styled-components";

import Axios from "axios";

import globalContext from "../../../Hooks/globalContext";
import languagePack from "../../../Utils/language";
import { HOST } from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import Loader from "../../../Components/Common/Loader";
import PageWrapper from "../../../Components/Common/PageWrapper";
import GoBack from "../../../Components/Common/GoBack";

const BottomWrapper = styled.div`
  background-color: ${(props) => props.theme.mainColor};
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 50px;
  width: 100%;
  padding: 2.5vh;

  cursor: pointer;
  :hover {
    opacity: 0.75;
  }
`;

const BottomWrapperGrey = styled(BottomWrapper)`
  background-color: ${(props) => props.theme.darkGrey};
`;

const ButtonText = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: white;
`;

const WebView = styled.div`
  width: 100%;
  padding-bottom: 7.5vh;
  overflow: auto;
  img {
    width: 100%;
  }
`;

const Container = ({ history, match }) => {
  const { language, httpHeader } = useContext(globalContext);
  const product = useState(null);

  const buyOnClick = async () => {
    history.push(`/market/order/${match.params.productId}`);
  };

  const getProduct = async () => {
    const { data } = await Axios.post(`${HOST}/market/product`, { id: match.params.productId }, httpHeader());
    product.setState(data);
  };

  const goBackOnClick = () => {
    history.push(`/market`);
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <PageWrapper>
      <GoBack onClick={goBackOnClick} />
      {product.state ? (
        <>
          <WebView
            dangerouslySetInnerHTML={{
              __html: `
      <div>
      ${product.state.content}
      </div>
      `,
            }}
          />
          {product.state.amount === 0 ? (
            <BottomWrapperGrey>
              <ButtonText>{languagePack("구매하기", language.state)}</ButtonText>
            </BottomWrapperGrey>
          ) : (
            <BottomWrapper onClick={buyOnClick}>
              <ButtonText>{languagePack("구매하기", language.state)}</ButtonText>
            </BottomWrapper>
          )}
        </>
      ) : (
        <Loader size={15} color="grey" />
      )}
    </PageWrapper>
  );
};

export default Container;
